const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3714_P0.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p0_w.path.beauty.linkName',
        title: 'p0_w.path.beauty.title',
        info: 'p0_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_Beauty_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.beauty.description.title',
          content: 'p0_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_EncuentraTalla_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p0_w.path.pickup.linkName',
        title: 'p0_w.path.pickup.title',
        info: 'p0_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_ReciclajeRopa_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_ReciclajeRopa.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.pickup.description.title',
          content: 'p0_w.path.pickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_PuntoRecogidaOnline_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P0_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3714_P1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_w.path.shoes.linkName',
        title: 'p1_w.path.shoes.title',
        info: 'p1_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_CalzadoComplementos_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_CalzadoComplementos.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.shoes.description.title',
          content: 'p1_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_w.path.pickUpSize.linkName',
        title: 'p1_w.path.pickUpSize.title',
        info: 'p1_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_EncuentraTalla_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickUpSize.description.title',
          content: 'p1_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_TurnoProbadores_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/refunds',
        exact: true,
        location: 'refunds',
        linkName: 'p1_w.path.refunds.linkName',
        title: 'p1_w.path.refunds.title',
        info: 'p1_w.path.refunds.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_Devoluciones_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_Devoluciones.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.refunds.description.title',
          content: 'p1_w.path.refunds.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_Autocobro_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P1_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
    ],
  },
  p2_k: {
    sectionPath: '/floor_2',
    locationKey: 'p2_k',
    sectionKey: 'KIDS',
    floorKey: '2',
    section: 'p2_k.section.name',
    floor: 'p2_k.floor.name',
    title: 'Título de la Planta 2',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/2/p/0962/428/407/33/w/649/0962428407_15_1_1.jpg?ts=1646994080095',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3714_P2.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P2.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_k.path.floorMap.linkName',
        title: 'p2_k.path.floorMap.title',
        info: 'p2_k.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P2.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_k.path.floorMap.description.title',
          content: 'p2_k.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p2_k.path.pickUpSize.linkName',
        title: 'p2_k.path.pickUpSize.title',
        info: 'p2_k.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P2_EncuentraTalla_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P2_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_k.path.pickUpSize.description.title',
          content: 'p2_k.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p3_m: {
    sectionPath: '/floor_3',
    locationKey: 'p3_m',
    sectionKey: 'MAN',
    floorKey: '3',
    section: 'p3_m.section.name',
    floor: 'p3_m.floor.name',
    title: 'Título del Sótano',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/3/p/2224/766/800/303/w/649/2224766800_15_1_1.jpg?ts=1642521515572',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3714_P3.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_S1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_3',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p3_m.path.floorMap.linkName',
        title: 'p3_m.path.floorMap.title',
        info: 'p3_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p3_m.path.floorMap.description.title',
          content: 'p3_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_3',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p3_m.path.shoes.linkName',
        title: 'p3_m.path.shoes.title',
        info: 'p3_m.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3_CalzadosComplementos_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3_CalzadosComplementos.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p3_m.path.shoes.description.title',
          content: 'p3_m.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_3',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p3_m.path.pickUpSize.linkName',
        title: 'p3_m.path.pickUpSize.title',
        info: 'p3_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3_EncuentraTalla_IMG1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3714_P3_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p3_m.path.pickUpSize.description.title',
          content: 'p3_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'nl-NL',
    name: 'Nederlands',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/3714_DEN_HAAG_IMG1.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
